import { Alert, Box, Card, CardContent, Link, Typography } from "@mui/material";
import { useMediaContext } from "context/MediaContext";
import { Game } from "model/Game";
import { Season } from "model/Season";
import { User } from "model/User";
import { useEffect, useState } from "react";
import GameHistory from "./MyPage/GameHistory/GameHistory_";

import * as seasonRepository from 'repository/SeasonRepository'
import * as gameRepository from 'repository/GameRepository'
import * as rankingRepository from 'repository/RankingRepository'
import { Ranking } from "model/Ranking";
import RankingTable from "./Ranking/RankingTable";
import { getString } from "script/dateutil";

type Props = {
  user: User
}
export default function Top(props: Props) {

  const media = useMediaContext()

  const [season, setSeason] = useState<Season | null>(null)
  useEffect(() => {
    seasonRepository
      .listFromCache(
        [
          { key: 'end_time', condition: '>=', value: new Date().getTime() }
        ],
        [
          { key: 'end_time', condition: 'asc'}
        ]
      )
      .then(it => {
        const target = it.find(_it => _it.start_time <= new Date().getTime())
        if (target) {
          setSeason(target!)
        } else {
          setSeason(it[0])
        }
      })
  }, [])

  const [game, setGame] = useState<Game | null>(null)
  useEffect(() => {
    if (!season) return
    gameRepository
      .listFromCache(
        [{key: 'season.id', condition: '==', value: season.id}],
        [{ key: 'end_time', condition: 'desc' }],
        1
      )
      .then(it => setGame(it[0]))
  }, [season])

  const [ranking, setRanking] = useState<Ranking | null>(null)
  useEffect(() => {
    if (!season) return
    rankingRepository.listFromCache(season).then(it => {
      it.users = it.users.slice(0, 3)
      setRanking(it)
    })
  }, [season])

  return (
    <Box sx={media.isPc ? { pt: 3, px: 5 } : { pt: 2, px: 3 }}>
      <Alert
        variant='outlined'
        severity='info'
        sx={{ backgroundColor: 'background.default', mb: 3 }}
      >
        <Typography variant='body2'>ユーザーのマッチング待機を通知するようになりました。</Typography>
        <Typography variant='body2'>詳細は以下のTweetをご確認ください。</Typography>
        <Link
          href='https://twitter.com/RforMD/status/1546885519203741696?s=20&t=4L3GYEtKlgWsJkDiGt_kwg'
          variant='body2'
          target='_blank'
        >
          マッチング通知について
        </Link>
      </Alert>
      <Card variant='outlined'>
        <CardContent>
          <Typography variant='body2' color='text.secondary'>
            『Rating for MasterDuel』は、KONAMI様が提供するゲーム『遊戯王 マスターデュエル』でのレーティング対戦を実現させたWebサービスです。
          </Typography>
          <Typography variant='body2' color='text.secondary'>
            他、戦績やマッチアップごとの勝率をみやすく表示する機能を利用して、環境への理解を深めることができます。
          </Typography>
        </CardContent>
      </Card>

      {season &&
        <Card variant='outlined' sx={{mt: 3}}>
          <CardContent>
            <Typography variant='body2' color='text.secondary'>
              以下の期間で「{season.name}」を開催します。
            </Typography>
            <Typography variant='body2' color='text.secondary'>
              {getString(new Date(season.start_time))} ~ {getString(new Date(season.end_time))}
            </Typography>
            <Typography variant='body2' color='text.secondary' sx={{mt: 2}}>
              また、「{season.name}」上位16名を最大1万円の賞金付き大会にご招待します。
            </Typography>
            <Typography variant='body2' color='text.secondary'>
              詳細は以下のDiscordサーバーをご確認ください。
            </Typography>
            <Link href='https://discord.gg/acSBGYESVg' variant='body2' target='_blank'>R4MD Cup</Link>
          </CardContent>
        </Card>
      }

      {game &&
        <Card variant='outlined' sx={{ mt: 3 }}>
          <CardContent>
            <Typography>最近の対戦</Typography>
            <GameHistory
              isOwnPage={false}
              user={props.user}
              game={game}
            />
          </CardContent>
        </Card>
      }

      {ranking &&
        <Card variant='outlined' sx={{ mt: 3 }}>
          <CardContent>
            <Typography>ランキングTop3</Typography>
            <RankingTable ranking={ranking} />
          </CardContent>
        </Card>
      }
    </Box>
  )
}